export default __webpack_public_path__ + "static/media/Flame Ammunition.c2120fbd.png";